'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'dumpster-fire';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f794';
var svgPathData = 'M32 32L0 160l114.9 0L140.5 32 32 32zM272 160l0-128-98.9 0L147.5 160 272 160zm32 0l56.5 0c19.7-21.2 40.4-38.5 57.8-50.8L402.9 32 304 32l0 128zm260.5-24.7c2.3 1.9 4.6 3.8 6.8 5.8L544 32 435.5 32l11.7 58.6 5.4-3.4L512 146.6l30-30 22.5 18.7zM288 319.8c0-49.2 20.9-93.1 46.1-127.8L32 192l4 32L0 224l0 64 44 0L64 448l0 32 64 0 0-32 209 0c-30.5-34-49-78.9-49-128.2zM448 128c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumpsterFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;